<template>
  <div class="columns" >
    <div class="column box ml-4 mb-2 is-two-fifths p-0" style="overflow: scroll;">
      <table class="table is-hoverable">
        <thead>
          <div class="px-6 is-flex my-3 is-align-items-center">
            <button @click="showLogConversation" class="button is-info is-small is-fullwidth">
              {{ hideLogs ? 'Show Logs' : 'Hide Logs' }}
            </button>
            <BaseDropdown
              wrapperClasses="column"
              dialogClass="p-0"
              :onDialogChange="onChange"
            >
              <template v-slot:toggle-button="{ handleToggle }">
                <div @click="handleToggle" class="button mx-4">{{ currentChoosenTemplate }}</div>
              </template>
              <div class="container py-3 px-2 max-width-dropdown">
                <label v-for="template in templates" :key="template.id">
                  <input type="radio" name="templates" :value="template.id" hidden />
                  <p class="search_result has-text-right">{{ template.text }}</p>
                </label>
              </div>
            </BaseDropdown>
          </div>
          <div class="px-3 mt-4">
            <input class="input" type="search" v-model="applicantsSearch" placeholder="חפש מועמד..."/>
          </div>
          <div class="px-4 mt-4">
            <Pagination v-if="paginationMeta" :totalPages="paginationMeta.total_pages" :currentPage="paginationMeta.current_page" @page-change="handlePageChange" @per-page-change="handlePerPageChange" />
          </div>
          <hr class="dropdown-divider mt-4" />
        </thead>
        <tbody>
          <tr class="is-clickable" v-for="applicant in applicantList" :key="applicant.id">
            <td @click="selectCurrentApplicant(applicant)" >
              <div class="is-flex is-justify-content-space-between is-align-items-center">
                <div>
                  {{ applicant.whatsapp_free_conversation ? '' : ' * '}}
                  <span v-if="applicant.unread_conversations_count" class="tag is-success">{{ applicant.unread_conversations_count }}</span>
                </div>
                <LinkEntity :payload="applicant" />
              </div>
              <div v-if="applicant.whatsapp_last_conversation" style="width:400px;" class="is-flex is-align-items-center">
                <span class="is-size-7" >
                  {{ $moment(applicant.whatsapp_last_conversation.created_at).format('DD/MM/YYYY HH:mm') }}
                </span>
                <span class="conversation-content has-text-right mx-4" style="width:250px;">
                  {{ applicant.whatsapp_last_conversation.content }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="currentApplicant" class="column box p-0 mb-2 is-flex is-flex-direction-column">
      <div class="box m-0 is-flex">
        <div>
          {{ currentApplicant.full_name }}
        </div>
        <!-- followup -->
        <button @click="openFollowUp" class="button is-info is-small mx-4 is-fullwidth mt-2">Follow up</button>
      </div>
      <div class="is-flex-grow-1" style="height: 80%;">
        <ModalWhatsappMessager :key="`${currentApplicant.resource_id}-${hideLogs}`" :hideLogs="hideLogs" :payload="{ props: { applicant: currentApplicant } }" />
      </div>
    </div>
    <div v-else class="column box p-0 mb-2"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import LinkEntity from '@/components/LinkEntity'
import ModalWhatsappMessager from '@/components/ModalWhatsappMessager'
import Pagination from '@/components/shared/organisms/Pagination'
import BaseDropdown from '@/components/BaseDropdown'

export default {
  name: 'ModalMasterWhatsapp',
  components: {
    LinkEntity,
    ModalWhatsappMessager,
    Pagination,
    BaseDropdown
  },
  data () {
    return {
      applicants: [],
      applicantsSearch: '',
      hideLogs: true,
      currentApplicant: null,
      page: 1,
      limit: 10,
      paginationMeta: null,
      currentChoosenTemplate: 'all',
      templates: [
        {
          id: '1',
          text: 'all',
          value: undefined
        },
        {
          id: '2',
          text: 'followup',
          value: 'initial_applicant_message'
        },
        {
          id: '3',
          text: 'vetting',
          value: 'welcome_questions_flow_familiar'
        },
        {
          id: '4',
          text: 'company process',
          value: 'company_process'
        }
      ]
    }
  },
  computed: {
    applicantList () {
      return this.applicants.filter(applicant => applicant.full_name.toLowerCase().includes(this.applicantsSearch.toLowerCase()))
    }
  },
  created () {
    this.getApplicantsList()
  },
  methods: {
    async getApplicantsList (template) {
      const designator = 'whatsapp_message,whatsapp_voice_message,whatsapp_template_send'
      const data = await this.$network_utils.getWhatsappApplicant({
        ...(this.hideLogs && { designator }),
        page: this.page,
        per_page: this.limit,
        template
      })
      this.applicants = data.data
      this.paginationMeta = data.meta
    },
    handlePerPageChange (v) {
      this.limit = v
      this.page = 1
      this.getApplicantsList()
    },
    handlePageChange (v) {
      this.page = v
      this.getApplicantsList()
    },
    selectCurrentApplicant (applicant) {
      this.currentApplicant = { ...applicant }
    },
    openFollowUp () {
      this.create({
        designator: 'resource-alerts-form-modal',
        component_name: 'ApplicantAlertsForm',
        modal_width: 2000,
        is_center_modal: true,
        data: this.currentApplicant,
        resource_type: 'Applicant',
        modal_title: `Alerts - ${this.$utils.getResourceFullName({ resource_type: 'Applicant', data: this.currentApplicant })} ${this.currentApplicant.phone_number}`,
        props: {
          sharedData: this.shared
        }
      })
    },
    showLogConversation () {
      this.hideLogs = !this.hideLogs
      this.currentChoosenTemplate = 'all'
      this.getApplicantsList()
    },
    onChange (e, closeModal) {
      const template = this.templates.find(t => t.id === e.target.value)
      if (!template) {
        this.currentChoosenTemplate = 'error'
        return
      }
      this.getApplicantsList(template.value)
      this.currentChoosenTemplate = template.text
      closeModal()
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>

<style scoped>
.conversation-content {
  white-space: nowrap;          /* Prevent text from wrapping */
  overflow: hidden;             /* Hide any overflow text */
  text-overflow: ellipsis;      /* Show ellipsis (...) for overflow text */
  max-width: 100%;
  display: block;
  font-size: 14px;
}
.max-width-dropdown {
    max-width: 500px;
    min-width: 250px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    max-height: 400px;
    overflow-y: scroll;
  }
</style>
